import React from "react";

import { AuthContextProvider } from "./Context/AuthContext/AuthContext";
import { FirebaseContextProvider } from "./Context/FirebaseContext/FirebaseContext";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

// import Login from "./Components/Loging";
// import { Input } from './Components/Commons';

//cache request
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { AppRoutes } from "./Routes/routes";
import { SafeAreaProvider } from "./Context/SafeAreaContext/SafeAreaContext";
import FirebaseAnalyticsService from "../src/Services/FirebaseAnalyticsService";
import { MixpanelProvider } from "./Context/MixpanelContext/MixpanelProvider";
import { ApplePayContextProvider } from "./Context/AppleContext/AppleContext";
import { IonApp, setupIonicReact } from "@ionic/react";
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

import "./App.css";
import store from "./Redux/store";
import ModalComponents from "./Routes/ModalComponents";
import { RevenueCatContextProvider } from "./Context/RevenueCatContext/RevenueCatContext";
import { SocketProvider } from "./Context/SocketContext/SocketProvider";
import { AppUpdateProvider } from "./Context/AppUpdateContext/AppUpdateProvider";
import { LeagueInfoProvider } from "./Context/LeagueInfoContext/LeagueInfoContext";
import { InitPushNotificationProvider } from "./Context/InitPushNotificationContext/InitPushNotificationProvider";
import { AppsFlyerProvider } from "./Context/AppsFlyerContext/AppsFlyerProvider";
import { AppReadyProvider } from "./Context/AppReadyContext/AppReadyContext";

setupIonicReact();
const queryClient = new QueryClient();

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <IonApp>
        <QueryClientProvider client={queryClient}>
          <AppReadyProvider>
            <FirebaseContextProvider>
              <MixpanelProvider>
                {/* <ApplePayContextProvider> */}
                <AuthContextProvider>
                <BrowserRouter>
                  <RevenueCatContextProvider>
                    <SocketProvider>
                      <LeagueInfoProvider>
                        <AppUpdateProvider>
                          <SafeAreaProvider>
                            <InitPushNotificationProvider>
                              <AppsFlyerProvider />
                              <AppRoutes />
                            </InitPushNotificationProvider>
                            <ModalComponents />
                            <FirebaseAnalyticsService />
                          </SafeAreaProvider>
                        </AppUpdateProvider>
                      </LeagueInfoProvider>
                    </SocketProvider>
                  </RevenueCatContextProvider>
                </BrowserRouter>
              </AuthContextProvider>
              {/* </ApplePayContextProvider> */}
            </MixpanelProvider>
          </FirebaseContextProvider>
        </AppReadyProvider>
        </QueryClientProvider>
      </IonApp>
    </Provider>
  );
};

export default App;
